export function initSupplierOnboardingFlow () {
  if (!$('body').hasClass('supplier_onboardings-controller')) return

  const checkbox = document.getElementById('edit-supplier-form-authorized')
  if (!checkbox?.form) return

  function sync () {
    const submit = checkbox.form.querySelector('input[type=submit]')
    if (submit) {
      submit.disabled = !checkbox.checked
    }
  }

  $(document)
    .off('change.supplierOnboarding', '#edit-supplier-form-authorized')
    .on('change.supplierOnboarding', '#edit-supplier-form-authorized', sync)
  sync()
}
